<svg viewBox="0 0 32 32" 
    xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M7 9h12v7H7v11.273c0 .398.332.727.75.727h16.5a.74.74 0 0 0 .75-.727V7.523h-5.864V2H7.75a.74.74 0 0 0-.75.727V9zM5 9V2.727C5 1.221 6.231 0 7.75 0h12.886L27 6v21.273C27 28.779 25.769 30 24.25 30H7.75C6.231 30 5 28.779 5 27.273V16H4V9h1zm19.64-2.477l-4.504-4.246v4.246h4.503zM5 10v5h13v-5H5z"/>
</svg>
